import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as selectores from "app/features/selectores/simples";
import { validation, formfields } from "kea-react"
import { componentToRx } from "react-rxk";
import { fa } from "typed-font-awesome";

type Entity = models.DatosComercial;
export interface Props {
    value: Entity;
    onChange: (value: Entity) => PromiseLike<void>;
    readonly?: boolean;
    error?: kea.FieldError;
}

/**
* Componente para editar un Entity
*/
class DatosComercialComponentNoRx extends React.PureComponent<Props> {
    value = (props: Props) => this.props.value;
 
    errors = () => validation.getErrors(this.rules, this.props.value);

    getField = formfields(() => this.props, () => this.errors());

    get rules(): validation.Rules<Entity> {
        return {};
    }

    render() {
        const { value } = this.props;
        const getField = this.getField;
        const Number = getField(kea.Number);
        const Text = getField(kea.Text);
        const GiroEmpresa = getField(selectores.GiroEmpresa);
        const Clasificacion = getField(selectores.Clasificacion);

        return (
            <div>
                <kea.Panel title="Datos comercial" iconClass={fa("id-card-o")} error={this.props.error} style="info">
                    {kea.autogrid(3, [
                        <GiroEmpresa field="GiroEmpresa" label="Giro de la empresa" />,
                        <Clasificacion field="Clasificacion" label="Clasificación" />,
                        <Number field="PotencialEnvioPkts" label="Potencial de envío" />,
                        <Number field="PotencialRecepcionPkts" label="Potencial de recepción" />,
                        <Number field="PotencialEnvioDinero" label="Potencial de envío en dinero" format="currency" />,
                        <Number field="PotencialRecepcionDinero" label="Potencial de recepción en dinero"format="currency"  />,
                    ])}
                </kea.Panel>
            </div>);
    }
}

export const DatosComercialComponent = componentToRx(kea.mapProps(DatosComercialComponentNoRx, x => ({ ...x, value: x.value || {} })), <kea.Spinner />, undefined, {
    error: { ignore: { observable: true, promise: true } }
});


// WEBPACK FOOTER //
// ./app/features/componentes/cliente/datosComercial.tsx